import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalize',
  standalone: true,
})
export class CapitalizePipe implements PipeTransform {
  transform(item: string | string[], attr: any): any {
    if (typeof item === 'string') {
      return this.capitalize(item.substr(0, 1)) + item.substr(1);
    } else {
      return item.map((i) => this.transform(i, attr));
    }
  }

  private capitalize(character: string): string {
    if (character === 'é' || character === 'ê') {
      return 'E';
    } else if (character === 'à') {
      return 'A';
    } else if (character === 'ç') {
      return 'C';
    }
    return character.toUpperCase();
  }
}
